<app-modal class="create-edit-pend-container"
             [header]="headerText"
             [(visible)]="visible"
             (visibleChange)="visibleChange.emit($event)" 
             (onHide)="close()"
            (onCancel)="close()">
  <div class="heading">Please enter the following criteria to create a pend code for your Service Organization</div>
  <div [hidden]="input.hidden" class="input" *ngFor="let input of inputs; trackBy: trackByIndex">
    <form-factory [formGroup]="form" [model]="input"></form-factory>
  </div>
  <footer>
   
    <app-button classes="secondary" [text]="saveOrCreate" (onClick)="save()"></app-button>
  </footer>
</app-modal>



